/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { isMacOs } from "react-device-detect";

import { ModKey } from "src/lib/types";

export const COMMAND_SYMBOL = isMacOs ? "⌘" : "ctrl-";

type Modifiers = { SHIFT: ModKey; COMMAND: ModKey };

export const MODIFIERS: Modifiers = {
  SHIFT: "shift",
  COMMAND: isMacOs ? "meta" : "ctrl",
};

export enum KeyCodes {
  ESCAPE = "Escape",
  A = "a",
  ARROW_LEFT = "ArrowLeft",
  ARROW_RIGHT = "ArrowRight",
  ARROW_UP = "ArrowUp",
  ARROW_DOWN = "ArrowDown",
  BACKSPACE = "Backspace",
  ENTER = "Enter",
}

export const HOTKEYS = {
  ESCAPE: { key: KeyCodes.ESCAPE, modifiers: [] },
  ENTER: { key: KeyCodes.ENTER, modifiers: [] },
  BACKSPACE: { key: KeyCodes.BACKSPACE, modifiers: [] },
  COMMAND_F: { key: "f", modifiers: [MODIFIERS.COMMAND] },
  COMMAND_A: { key: KeyCodes.A, modifiers: [MODIFIERS.COMMAND] },
  COPY: { key: "c", modifiers: [MODIFIERS.COMMAND] },
  CUT: { key: "x", modifiers: [MODIFIERS.COMMAND] },
  SEARCH: { key: "k", modifiers: [MODIFIERS.COMMAND] },
  COMMAND_PALETTE: { key: "k", modifiers: [MODIFIERS.COMMAND, MODIFIERS.SHIFT] },
  NEW_PLATE: { key: "n", modifiers: [MODIFIERS.COMMAND] },
  ARROW_RIGHT: { key: KeyCodes.ARROW_RIGHT, modifiers: [] },
  ARROW_LEFT: { key: KeyCodes.ARROW_LEFT, modifiers: [] },
  ARROW_UP: { key: KeyCodes.ARROW_UP, modifiers: [] },
  ARROW_DOWN: { key: KeyCodes.ARROW_DOWN, modifiers: [] },
  SHIFT_ARROW_RIGHT: { key: KeyCodes.ARROW_RIGHT, modifiers: [MODIFIERS.SHIFT] },
  SHIFT_ARROW_LEFT: { key: KeyCodes.ARROW_LEFT, modifiers: [MODIFIERS.SHIFT] },
  SHIFT_ARROW_UP: { key: KeyCodes.ARROW_UP, modifiers: [MODIFIERS.SHIFT] },
  SHIFT_ARROW_DOWN: { key: KeyCodes.ARROW_DOWN, modifiers: [MODIFIERS.SHIFT] },
  UNDO: { key: "z", modifiers: [MODIFIERS.COMMAND] },
  REDO: { key: "z", modifiers: [MODIFIERS.COMMAND, MODIFIERS.SHIFT] },
  CHANGE_THEME: { key: "0", modifiers: [MODIFIERS.COMMAND, MODIFIERS.SHIFT] },
};
